/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FieldRequireTypes,
    FieldRequireTypesFromJSON,
    FieldRequireTypesFromJSONTyped,
    FieldRequireTypesToJSON,
} from './';

/**
 * 
 * @export
 * @interface CreateFailureStatusCommand
 */
export interface CreateFailureStatusCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateFailureStatusCommand
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateFailureStatusCommand
     */
    alternativeName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateFailureStatusCommand
     */
    isSpecialCase: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateFailureStatusCommand
     */
    isSealed: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateFailureStatusCommand
     */
    isDefault: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateFailureStatusCommand
     */
    requiresWorkbookTask: boolean;
    /**
     * 
     * @type {FieldRequireTypes}
     * @memberof CreateFailureStatusCommand
     */
    requiresStateChangeReason: FieldRequireTypes;
}

export function CreateFailureStatusCommandFromJSON(json: any): CreateFailureStatusCommand {
    return CreateFailureStatusCommandFromJSONTyped(json, false);
}

export function CreateFailureStatusCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFailureStatusCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'alternativeName': !exists(json, 'alternativeName') ? undefined : json['alternativeName'],
        'isSpecialCase': json['isSpecialCase'],
        'isSealed': json['isSealed'],
        'isDefault': json['isDefault'],
        'requiresWorkbookTask': json['requiresWorkbookTask'],
        'requiresStateChangeReason': FieldRequireTypesFromJSON(json['requiresStateChangeReason']),
    };
}

export function CreateFailureStatusCommandToJSON(value?: CreateFailureStatusCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'alternativeName': value.alternativeName,
        'isSpecialCase': value.isSpecialCase,
        'isSealed': value.isSealed,
        'isDefault': value.isDefault,
        'requiresWorkbookTask': value.requiresWorkbookTask,
        'requiresStateChangeReason': FieldRequireTypesToJSON(value.requiresStateChangeReason),
    };
}


